import { createStore, Store } from 'vuex';

import auth from './auth';
import firestore from './firestore';
import notifications from './notifications';
import theme from './theme';

import { state, RootStateI } from './state';
import { mutations } from './mutations';

const store: Store<RootStateI> = createStore({
  state,
  getters: {
  },
  mutations,
  actions: {
  },
  modules: {
  },
});

store.registerModule('auth', auth);
store.registerModule('firestore', firestore);
store.registerModule('notifications', notifications);
store.registerModule('theme', theme);

export default store;
